import React         from 'react';
import merge         from 'deepmerge';
import { Observe }        from 'rewire-core';
import {
  Dialog
  as
  RewireDialog,
  DialogProps
  as
  RewireDialogProps,
  IDialogProps,
}                         from 'rewire-ui';
import {
  MuiThemeProvider,
  Theme
}                         from '@material-ui/core/styles';
import                    './dialog.css';
import { withStyles } from '../utility/styles';

export const dialogTheme = (outerTheme: Theme) => ({
  ...outerTheme,
  palette: merge(outerTheme.palette, {
    primary: {
      light: outerTheme.palette.dialogPrimary.light,
      main: outerTheme.palette.dialogPrimary.main,
      dark: outerTheme.palette.dialogPrimary.dark,
      contrastText: outerTheme.palette.dialogPrimary.contrastText,
    },
  }),
  overrides: merge(outerTheme.overrides!, {
    MuiDialog: {
      paperWidthXs: {
        maxWidth: '400px',
      },
    },
    MuiButton: {
      root: {
        textTransform: 'uppercase',
        minWidth: '90px',
      },
    },
  }),
} as Theme);

export const dialogStyles = (theme: Theme) => ({
  root: {
    borderRadius: '10px',
  },
  heading: {
    padding: '15px',
    alignItems: 'flex-start',
    justifyContent: 'center',
    backgroundColor: theme.palette.neutralLight.main,
    color: theme.palette.dialogPrimary.main,
    '& > hr': {
      display: 'none',
    }
  },
  buttons: {
    margin: '10px 0px',
    '& > *': {
      marginLeft: '0px',
      marginRight: '15px',
    },
  },
  divider: {
  },
  childrenContainer: {
  },
});

class Dialog extends React.Component<RewireDialogProps> {
  render() {
    const {classes, children, dialog, ...restProps} = this.props;

    return <Observe render={() => (
      <MuiThemeProvider theme={dialogTheme}>
        <RewireDialog dialog={dialog} classes={classes} {...restProps}>
          {children}
        </RewireDialog>
      </MuiThemeProvider>
    )} />;
  }
}

export default withStyles<IDialogProps>(dialogStyles, Dialog);
